import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import "./Companylist.css";
import Breadcrumb from "../../Layout/Breadcrumb/Breadcrumb";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import Nav from "../../Layout/Nav/Nav";
// import { useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import ButtonCall from "../UiSpecification/Button/Button";
import UnLinkButton from "../UiSpecification/UnLinkButton/UnLinkButton";
import ActionButtonCall from "../UiSpecification/ActionButton/ActionButton";
import UnLinkActionButtonCall from "../UiSpecification/UnLinkActionButton/UnLinkActionButton";

import { MasterData } from "../../Helpers/Data/MasterData/MasterData";
import { CatMasterData } from "../../Helpers/Data/CatMasterData/CatMasterData";
import { Company } from "../../Helpers/Data/Company/Company";
import { Contact } from "../../Helpers/Data/Contact/Contact";
import { Unit } from "../../Helpers/Data/Unit/Unit";

import sitelogo from "../../../Images/t1.jpg";

import DataTable, { createTheme } from "react-data-table-component";

// function ActionButtonCall(props) {

//   return (
//     iconButtons
//     .filter((ibtn) => ibtn.name == props.btnname)
//     .map((filteredIbtn) => <li key={filteredIbtn.id}>{filteredIbtn.button}</li>)
//   );
// }

function Companylist() {
  const [MasterDataStore, setMasterDataStore] = useState(MasterData);
  // console.log({ MasterDataStore });

  const [CatMasterDataStore, setCatMasterDataStore] = useState(CatMasterData);
  // console.log({ CatMasterDataStore });

  const [SelectedMasterDataStore, setSelectedMasterDataStore] = useState({
    MasterDataCategory: "",
  });
  const handleMasterDataInput = (e) => {
    setSelectedMasterDataStore({
      ...SelectedMasterDataStore,
      [e.target.name]: e.target.value,
    });
  };

  const [CompanyStore, setCompanyStore] = useState(Company);
  // console.log({ CompanyStore });

  const [ContactStore, setContactStore] = useState(Contact);
  // console.log({ ContactStore });

  const [SelectedCompanyStore, setSelectedCompanyStore] = useState({
    company: "",
  });
  const handleCpmpanyInput = (e) => {
    setSelectedCompanyStore({
      ...SelectedCompanyStore,
      [e.target.name]: e.target.value,
    });
  };
  // console.log({SelectedCompanyStore});

  // const [records, setRecords] = useState(data);

  // function handleFilter(event) {
  //   const newData = data.filter((row) => {
  //     return row.title.toLowerCase().includes(event.target.value.toLowerCase());
  //   });
  //   setRecords(newData);
  // }
  // End List Table

  // Add Item Modal
  const [showAddJob, setShowAddJob] = useState(false);
  const handleClose = () => setShowAddJob(false);
  const handleShow = () => setShowAddJob(true);

  const [modalType, setModalType] = useState("");

  // Add Item Inventory
  const [addJobInventoryType, SetaddJobInventoryType] = useState("master");

  // All Added items
  const [insrtedAllTypeItemStore, setinsrtedAllTypeItemStore] = useState([]);

  // Add Inventory Type Body
  // const [jobInventoryBodyType, SetjobInventoryBodyType] = useState("master");

  // Inventor Item Insert
  //   master
  // ======
  // selectMasterItem
  // MasterItemCount

  // custom
  // =====
  // CustomItemName
  // CustomItemDescription
  // CustomItemCount
  // CustomItemUnit

  //  ============= Master Item add ===========
  const [insertMasterItem, setinsertMasterItem] = useState({
    selectMasterItem: "",
    MasterItemCount: "",
  });
  const insertMasterItemParser = (e) => {
    setinsertMasterItem({
      ...insertMasterItem,
      [e.target.name]: e.target.value,
    });
  };
  const [insertMasterItemStore, setinsertMasterItemStore] = useState([]);

  //  ============ Custom Item Add ===========
  const [insertCustomItem, setinsertCustomItem] = useState({
    CustomItemName: "",
    CustomItemDescription: "",
    CustomItemCount: "",
    CustomItemUnit: "",
    CustomItemPrice: "",
  });
  const insertCustomItemParser = (e) => {
    setinsertCustomItem({
      ...insertCustomItem,
      [e.target.name]: e.target.value,
    });
  };
  const [insertCustomItemStore, setinsertCustomItemStore] = useState([]);

  // ======Submit=====

  // const SubmitinsertAllItemParser = (e) => {
  //   addJobInventoryType == "master"
  //     ?
  //     setinsertMasterItemStore({
  //       selectMasterItem: insertMasterItem.selectMasterItem,
  //       MasterItemCount: insertMasterItem.MasterItemCount,
  //     })  :
  // setinsertCustomItemStore({
  //   CustomItemName :insertCustomItem.CustomItemName,
  //   CustomItemDescription :insertCustomItem.CustomItemDescription,
  //   CustomItemCount :insertCustomItem.CustomItemCount,
  //   CustomItemUnit :insertCustomItem.CustomItemUnit,
  // });

  //   addJobInventoryType == "master"
  //   ? setinsrtedAllTypeItemStore({...insrtedAllTypeItemStore, insertMasterItemStore})
  //   : setinsrtedAllTypeItemStore({...insrtedAllTypeItemStore, insertCustomItemStore});
  // };

  const SubmitinsertAllItemParser = () => {
    if (addJobInventoryType == "master") {
      if (
        insertMasterItem.selectMasterItem != "" &&
        insertMasterItem.MasterItemCount != ""
      ) {
        setinsertMasterItemStore((insertMasterItemStore) => [
          ...insertMasterItemStore,
          insertMasterItem,
        ]);
        setinsrtedAllTypeItemStore((insrtedAllTypeItemStore) => [
          ...insrtedAllTypeItemStore,
          insertMasterItem,
        ]);
        // console.log(nameTwo);
        setinsertMasterItem({
          selectMasterItem: "",
          MasterItemCount: "",
        });
      }

      // setNameThree({
      //   ...nameThree,
      //   nameTwo,
      // });
      // working===setNameThree(prevStateArray => [...prevStateArray, nameTwo]);

      // console.log(nameThree);
    } else {
      if (
        insertCustomItem.CustomItemName != "" &&
        insertCustomItem.CustomItemDescription != "" &&
        insertCustomItem.CustomItemCount != "" &&
        insertCustomItem.CustomItemUnit != ""
      ) {
        setinsertCustomItemStore((insertCustomItemStore) => [
          ...insertCustomItemStore,
          insertCustomItem,
        ]);
        setinsrtedAllTypeItemStore((insrtedAllTypeItemStore) => [
          ...insrtedAllTypeItemStore,
          insertCustomItem,
        ]);
        // console.log(nameTwo);
        setinsertCustomItem({
          CustomItemName: "",
          CustomItemDescription: "",
          CustomItemCount: "",
          CustomItemUnit: "",
          CustomItemPrice: "",
        });
      }
      // setNameThree({
      //   ...nameThree,
      //   nameTwoB,
      // });
      // working====setNameThree(prevStateArray => [...prevStateArray, nameTwoB]);

      // console.log(nameThree);
    }
    // toggler == true ? console.log("True") : console.log("false");
  };

  // console.log(insrtedAllTypeItemStore);

  // List Table
  const columns = [
    {
      name: "Logo",
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      // width: "720px",
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      // width: "720px",
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => row.action,
      sortable: true,
    },
  ];

  const data = [
    {
      id: "1",
      code: (<img className="logo-img" src={sitelogo}/>),
      name: "Las Ventanas",
      phone: "765-479-4444",
      email: "lasventanas@gmail.com",
      action: (
        <div className="icon-button-parent">
          {
            <>
              {/* <ActionButtonCall btnname="edit" />{" "} */}
              <UnLinkActionButtonCall
                trigerClick={handleShow}
                modalStateAndValue={{
                  setState: setModalType,
                  setStateValue: "edit",
                }}
                btnname="edit"
                title="Edit Master Data"
              />

              <ActionButtonCall urlto="/contact" btnname="add_subscriber" />

              <ActionButtonCall btnname="disable" />
            </>
          }
        </div>
      ),
    },

    {
      id: "2",
      code: (<img className="logo-img" src={sitelogo}/>),
      name: "Saepe Eveniet",
      phone: "355-886-8856",
      email: "saepeeveniet@gmail.com",
      action: (
        <div className="icon-button-parent">
          {
            <>
              {/* <ActionButtonCall btnname="edit" />{" "} */}
              <UnLinkActionButtonCall
                trigerClick={handleShow}
                modalStateAndValue={{
                  setState: setModalType,
                  setStateValue: "edit",
                }}
                btnname="edit"
                title="Edit Master Data"
              />

<ActionButtonCall urlto="/contact" btnname="add_subscriber" />

              <ActionButtonCall btnname="disable" />
            </>
          }
        </div>
      ),
    },

    {
      id: "3",
      code: (<img className="logo-img" src={sitelogo}/>),
      name: "Voluptates",
      phone: "256-111-7537",
      email: "voluptates@gmail.com",
      action: (
        <div className="icon-button-parent">
          {
            <>
              {/* <ActionButtonCall btnname="edit" />{" "} */}
              <UnLinkActionButtonCall
                trigerClick={handleShow}
                modalStateAndValue={{
                  setState: setModalType,
                  setStateValue: "edit",
                }}
                btnname="edit"
                title="Edit Master Data"
              />

<ActionButtonCall urlto="/contact" btnname="add_subscriber" />
              <ActionButtonCall btnname="disable" />
            </>
          }
        </div>
      ),
    },
  ];

  const [records, setRecords] = useState(data);

  function handleFilter(event) {
    const newData = data.filter((row) => {
      return row.name.toLowerCase().includes(event.target.value.toLowerCase());
    });
    setRecords(newData);
  }

  return (
    <div className="page-con">
      <div className="page-nav">
        <Nav />
      </div>

      <div className="page-body">
        <Header />

        <div className="comb-sec breadcrumb-sec">
          <div className="container-fluid px-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb my-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                {/* <li className="breadcrumb-item">
                  <Link to="/job">Job List</Link>
                </li> */}
                <li className="breadcrumb-item">
                  <span>Company</span>
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="page-content-container">
          {
            // insrtedAllTypeItemStore.map((item) => (
            //                   <p>
            //                     <>
            //                       xx
            //                       {/* {SelectedCompanyStore.company} */}
            //                     </>
            //                   </p>
            //                 ))
          }

          <div className="dataTable-con">
            <div className="dataTable-serach-con dataTable-serach-con-button">
              <div className="dataTable-serach-con-button-left">
                <input
                  type="text"
                  className="dataTable-serach-input"
                  placeholder="Search"
                  onChange={handleFilter}
                />
              </div>

              <div className="dataTable-serach-con-button-right">
                {
                  <UnLinkButton
                    trigerClick={handleShow}
                    modalStateAndValue={{
                      setState: setModalType,
                      setStateValue: "add",
                    }}
                    // modalTogglerState={setModalType}
                    // modalTogglerStateValue={"edit"}
                    btnname="add"
                    title="Add New Company"
                  />
                }
              </div>
            </div>
            <div className="dataTable-table-con dataTable-table-company">
              <DataTable
                columns={columns}
                data={records}
                fixedHeader
                pagination
                // theme="solarized"
              />
            </div>
          </div>

          <>
            <Modal
              show={showAddJob}
              onHide={handleClose}
              className="full-modal-con"
            >
              {modalType == "add" && (
                <>
                  <Modal.Header closeButton>
                    <Modal.Title>Add New Company</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <>
                        <Container className="cus-con-elmt">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Name
                                </Form.Label>
                                <Form.Control
                                  value={insertCustomItem.CustomItemName}
                                  type="text"
                                  id="CustomItemName"
                                  name="CustomItemName"
                                  onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="lable-before_after-unsetter-con"
                            >
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobDesc">
                                  Description
                                </Form.Label>
                                <FloatingLabel label="">
                                  <Form.Control
                                    value={
                                      insertCustomItem.CustomItemDescription
                                    }
                                    as="textarea"
                                    placeholder=""
                                    style={{ height: "100px" }}
                                    id="CustomItemDescription"
                                    name="CustomItemDescription"
                                    onChange={insertCustomItemParser}
                                  />
                                </FloatingLabel>
                              </div>
                            </Col>

                            {/* <Col xs={12} md={4} lg={4}>
                            <div className="form-group-con">
                              <Form.Label htmlFor="addJobTitle">
                                Unit
                              </Form.Label>
                              <Form.Control
                                value={insertCustomItem.CustomItemUnit}
                                type="text"
                                id="CustomItemUnit"
                                name="CustomItemUnit"
                                onChange={insertCustomItemParser}
                              />
                             
                            </div>
                          </Col> */}

                        <Col xs={12} md={12} lg={12}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Address
                                </Form.Label>
                                <Form.Control
                                  // value=""
                                  type="text"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>

                            <Col xs={12} md={6} lg={6}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Phone
                                </Form.Label>
                                <Form.Control
                                  // value=""
                                  type="text"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>

                            <Col xs={12} md={6} lg={6}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Email
                                </Form.Label>
                                <Form.Control
                                  // value=""
                                  type="email"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Web Site
                                </Form.Label>
                                <Form.Control
                                  // value=""
                                  type="email"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Logo
                                </Form.Label>
                                <Form.Control
                                  type="file"
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}

                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>
                          </Row>
                        </Container>
                      </>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    {
                      <UnLinkButton
                        trigerClick={handleClose}
                        btnname="save"
                        title="Save"
                      />
                    }
                    {
                      <UnLinkButton
                        trigerClick={handleClose}
                        btnname="close"
                        title="Cancel"
                      />
                    }
                    {/* SubmitinsertMasterItemParser */}
                  </Modal.Footer>
                </>
              )}

              {modalType == "edit" && (
                <>
                  <Modal.Header closeButton>
                    <Modal.Title>Edit Company</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <>
                        <Container className="cus-con-elmt">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Title
                                </Form.Label>
                                <Form.Control
                                  value={"Las Ventanas"}
                                  type="text"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="lable-before_after-unsetter-con"
                            >
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobDesc">
                                  Description
                                </Form.Label>
                                <FloatingLabel label="">
                                  <Form.Control
                                    value="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
                                    as="textarea"
                                    placeholder=""
                                    style={{ height: "100px" }}
                                    // id="CustomItemDescription"
                                    // name="CustomItemDescription"
                                    // onChange={insertCustomItemParser}
                                  />
                                </FloatingLabel>
                              </div>
                            </Col>

                            {/* <Col xs={12} md={4} lg={4}>
                            <div className="form-group-con">
                              <Form.Label htmlFor="addJobTitle">
                                Unit
                              </Form.Label>
                              <Form.Control
                                value={insertCustomItem.CustomItemUnit}
                                type="text"
                                id="CustomItemUnit"
                                name="CustomItemUnit"
                                onChange={insertCustomItemParser}
                              />
                             
                            </div>
                          </Col> */}

                            <Col xs={12} md={4} lg={4}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Phone
                                </Form.Label>
                                <Form.Control
                                  value="765-479-4444"
                                  type="text"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>

                            <Col xs={12} md={4} lg={4}>
                              <div className="form-group-con">
                                <Form.Label htmlFor="addJobTitle">
                                  Email
                                </Form.Label>
                                <Form.Control
                                  value="lasventanas@gmail.com"
                                  type="email"
                                  // id="CustomItemName"
                                  // name="CustomItemName"
                                  // onChange={insertCustomItemParser}
                                  // aria-describedby="passwordHelpBlock"
                                />
                                {/* <Form.Text id="passwordHelpBlock" muted>
                    ...
                  </Form.Text> */}
                              </div>
                            </Col>
                          </Row>
                        </Container>
                      </>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    {
                      <UnLinkButton
                        trigerClick={handleClose}
                        btnname="update"
                        title="Update"
                      />
                    }
                    {
                      <UnLinkButton
                        trigerClick={handleClose}
                        btnname="close"
                        title="Cancel"
                      />
                    }
                    {/* SubmitinsertMasterItemParser */}
                  </Modal.Footer>
                </>
              )}

              {modalType == "" && (
                <>
                  <Modal.Header closeButton>
                    <Modal.Title>Modal</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <>
                        <Container className="cus-con-elmt">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              Empty Modal
                            </Col>
                          </Row>
                        </Container>
                      </>
                    </Form>
                  </Modal.Body>
                </>
              )}
            </Modal>
          </>
        </div>

        <Footer />
      </div>
    </div>
  );
}
export default Companylist;
